/* eslint-disable i18next/no-literal-string */
"use client";

import Image from "next/image";
import { Noise } from "@ui/components/core/Noise/Noise";
import { SeamlessTexture } from "@ui/components/core/SeamlessTexture/SeamlessTexture";

import coverReference from "./images/popover-background.webp";

export function TTSDownloadPopoverCover() {
  return (
    <div inert className='tw-relative tw-h-full tw-w-full tw-overflow-hidden tw-bg-black'>
      <Image src={coverReference} alt='' fill priority className='tw-object-cover tw-object-left-top' aria-hidden />
      <SeamlessTexture className='tw-pointer-events-none tw-opacity-20' aria-hidden />
      <Noise className='tw-pointer-events-none tw-opacity-60' aria-hidden />

      <div
        aria-hidden
        className='tw-pointer-events-none tw-absolute -tw-left-[0.5rem] -tw-top-[1.5rem] tw-w-[min(100%,21.25rem)] tw-text-white/25 tw-type-sm tw-leading-[1.45]'
      >
        <p>
          The cabin lights flickered, and she caught her reflection in the glass - eyes half-awake,
          <span className='tw-text-white/40'> [pauses]</span> trying to remember what day it was.
        </p>
        <p className='tw-mt-4'>
          She tapped the console again,
          <span className='tw-text-white/40'> [laughs softly]</span>. The static replied with a sigh of its own, patient
          and unhelpful.
        </p>
      </div>

      <div className='tw-pointer-events-none tw-absolute tw-inset-x-0 tw-bottom-0 tw-z-10 tw-h-24 tw-bg-gradient-to-t tw-from-paper tw-to-transparent' />
    </div>
  );
}
